function Footer () {
  return (
    <div>
      <ul>
        <li>Home</li>
        <li>About us</li>
        <li>Create your plan</li>
      </ul>
    </div>
  )
}

export default Footer;
